import { createSelector } from '@ngrx/store';
import { getRmsSpecificationPage } from './index';

export const getRmsModifyFlag = createSelector(getRmsSpecificationPage, state => state.rmsModifyFlag);
